import { Modals } from 'presentation/libs/modals'

const MODAL_KEY = 'MLSStatusTrainingModal'

export const useMLSStatusTrainingModal = Modals.createHistoryUseModal(MODAL_KEY)
